import { money2 } from "@/lib/api";

/** The single client-facing rendering of an invoice, shared by the preview, the
 *  invoice page modal and the public invoice page, so all three always agree. */
export default function ClientInvoiceBlocks({ invoice, testPrefix = "client-block" }) {
  const blocks = invoice.groups || (invoice.line_items || []).map((l, i) => ({
    id: `line-${i}`, title: l.description, amount: l.amount, items: [],
  }));
  return (
    <>
      <div className="space-y-5">
        {blocks.map((g) => (
          <div key={g.id} className="border-b border-line pb-4" data-testid={`${testPrefix}-${g.id}`}>
            <div className="flex items-baseline justify-between gap-4">
              <span className="text-ink">{g.title}</span>
              {g.amount !== undefined && <span className="num text-ink">{money2(g.amount)}</span>}
            </div>
            {g.description && <p className="mt-1 text-xs text-stone">{g.description}</p>}
            {g.quantity !== undefined && (
              <p className="mt-1 text-xs text-fog">
                {g.quantity} × {money2(g.unit_price)}
              </p>
            )}
            {!!g.items?.length && (
              <ul className="mt-3 space-y-2 text-sm text-stone">
                {g.items.map((it) => (
                  <li key={it.id} className="flex items-baseline justify-between gap-4">
                    <span>
                      {it.name || "Selection"}
                      {it.quantity !== undefined && <span className="text-fog"> × {it.quantity}</span>}
                      {it.vendor_name && <span className="text-fog"> · {it.vendor_name}</span>}
                      {it.description && <span className="block text-xs text-fog">{it.description}</span>}
                    </span>
                    <span className="num">{money2(it.amount)}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
      <div className="mt-7 space-y-2 text-sm">
        <div className="flex justify-between"><span className="text-stone">Subtotal</span><span className="num text-ink">{money2(invoice.subtotal)}</span></div>
        {invoice.tax > 0 && (
          <div className="flex justify-between"><span className="text-stone">Tax</span><span className="num text-ink">{money2(invoice.tax)}</span></div>
        )}
        <div className="flex justify-between"><span className="text-stone">Total</span><span className="num text-ink">{money2(invoice.total)}</span></div>
        {invoice.amount_paid > 0 && (
          <div className="flex justify-between"><span className="text-stone">Paid to date</span><span className="num text-lime-dark">-{money2(invoice.amount_paid)}</span></div>
        )}
        <div className="flex justify-between border-t border-line pt-3">
          <span className="text-ink">Balance due</span>
          <span className="num text-lg text-ink">{money2(invoice.balance ?? invoice.total)}</span>
        </div>
      </div>
    </>
  );
}
